export enum Language {
    FR = 'fr',
    EN = 'en',

    // EN_GB is use over EN for use britain date's format on local ID
    EN_GB = 'en-GB',

    NL_NL = 'nl-NL'
}
